import { PartialSong } from '@redux/player/types';
import * as Sentry from '@sentry/browser';
import { Song } from 'src/@types/api-types';

export const SECONDS_TO_MS_RATIO = 1000;

export const secondsToMinutesAndSeconds = (seconds: number, dense = false): string => {
  const formattedMinutesAndSeconds = new Date(seconds * 1000).toISOString().substr(14, 5);
  return dense ? formattedMinutesAndSeconds : formattedMinutesAndSeconds.replace(':', ' : ');
};

export const secondsToHoursAndMinutes = (seconds: number) => {
  // warning: this helper only works for durations of less than 1 day
  const date = new Date(seconds * 1000);
  return `${date.getUTCHours()}h ${date.getUTCMinutes() < 10 ? '0' : ''}${date.getUTCMinutes()}min`;
};

const padNumberOfTimeUnits = (numberOfTimeUnits: number) =>
  String(numberOfTimeUnits).padStart(2, '0');

export const millisecondsToHoursAndMinutes = (milliseconds: number) => {
  const seconds = milliseconds / SECONDS_TO_MS_RATIO;
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return `${padNumberOfTimeUnits(hours)} h ${padNumberOfTimeUnits(minutes)} min`;
};

export const getSonglistDuration = (songList: (PartialSong | Song)[], lastSongDuration: number): string => {
  let duration = 0;



  try {
    duration = songList.reduce((duration, song) => {
      return duration + song.length;
    }, 0);
  } catch (error) {
    Sentry.withScope((scope) => {
      scope.setExtras({ songList });
      Sentry.captureException(error);
    });
  }

  duration += lastSongDuration;

  return secondsToHoursAndMinutes(duration);
};

export const getRemainingTimeInMilliseconds = (timestamp: string) => {
  return new Date(timestamp).getTime() - new Date().getTime();
};

export const QUARTER_HOUR_TO_HOUR_RATIO = 0.25;
